import { render, staticRenderFns } from "./AssistantContainer.vue?vue&type=template&id=243fcb9a&"
import script from "./AssistantContainer.vue?vue&type=script&lang=ts&"
export * from "./AssistantContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AssistantContainer.vue?vue&type=style&index=0&id=243fcb9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports